const ITEMS = [
  "Brand strategy",
  "Offer design",
  "Content engine",
  "Sales practice",
  "Embodied pace",
  "Self-image work",
  "Real community",
];

export const Marquee = () => (
  <div
    className="overflow-hidden border-y border-white/10 bg-ink py-5"
    data-testid="marquee"
  >
    <div className="marquee-track flex w-max items-center">
      {[0, 1].map((dup) => (
        <div
          key={dup}
          aria-hidden={dup === 1}
          className="flex items-center"
        >
          {ITEMS.map((item, i) => (
            <span key={i} className="flex items-center">
              <span className="whitespace-nowrap px-8 font-mont text-2xl font-bold text-white/70 sm:text-3xl">
                {item}
              </span>
              <span className="inline-block h-1.5 w-1.5 bg-forest" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);

export default Marquee;
